import { ListItem, ListItemText, Typography, Chip, Stack } from '@mui/material';
import { format, formatDistanceToNow } from 'date-fns';
import PropTypes from 'prop-types';

export default function NotificationItem({ notification }) {
  const { title, description, sender, createdAt, isUnRead, type } = notification;

  return (
    <ListItem
      sx={{
        px: 2.5,
        py: 1.5,
        bgcolor: isUnRead ? 'action.focus' : 'background.paper',
      }}
    >
      <ListItemText
        primary={
          <Typography variant="subtitle2">{title}</Typography>
        }
        secondary={
          <Stack spacing={1}>
            <Typography variant="body2">{description}</Typography>
            <Typography variant="caption" color="text.secondary">
              {formatDistanceToNow(new Date(createdAt), { addSuffix: true })} • {format(new Date(createdAt), 'dd MMM yyyy')}
            </Typography>
          </Stack>
        }
      />
    </ListItem>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    sender: PropTypes.string,
    createdAt: PropTypes.string,
    isUnRead: PropTypes.bool,
    type: PropTypes.string,
    text: PropTypes.object,
  }),
};